<template>
  <div class="categories">
    <v-list>
      <v-list-tile
        ripple
        v-for="item in items"
        :key="item.id"
        @click="setCurrentCategory(item.id)">
        <v-list-tile-content>
          <v-list-tile-title v-text="item.name"></v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action @click="removeItem(item.id)">
          <v-icon color="grey lighten-1">{{ tileActionIcon }}</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
  export default {
    name: 'categories',
    computed: {
      items () {
        return this.$store.getters.getCategories
      },
      tileActionIcon () {
        return this.$store.getters.getEditMode ? 'close' : 'arrow_forward'
      }
    },
    methods: {
      setCurrentCategory (catId) {
        if (!this.$store.getters.getEditMode) {
          this.$router.push({name: 'category', params: {id: catId}})
          this.$store.commit('SET_NAV_DIRECTION', 'forward')
          this.$store.commit('SET_CURRENT_CATEGORY', catId)
        }
      },
      removeItem (id) {
        if (this.$store.getters.getEditMode) {
          this.$store.commit('REMOVE_CATEGORY', id)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Categories.vue?2caf7c86